<template>
  <div class="D106">
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>申報年度</td>
                  <td>
                    <select v-model="form.syear">
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關</td>
                  <td colspan="3">
                    <select
                      v-model="form.jobGovCode1"
                      style="min-width: 200px"
                      @change="JobGovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode2"
                      style="min-width: 200px"
                      @change="JobGovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode3"
                      style="min-width: 200px"
                      @change="JobGovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.jobGovCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td height="47">輸出格式</td>
                  <td>
                    <p>
                      <label>
                        <input
                          type="radio"
                          checked="checked"
                          v-model="form.printtype"
                          value="XLSX"
                        />

                        XLSX</label
                      >
                      <label>
                        <input
                          type="radio"
                          v-model="form.printtype"
                          value="ODS"
                          checked="checked"
                          display
                        />
                        ODS</label
                      >
                      <br />
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="button"
                          class="btn"
                          value="產生報表"
                          @click="btnPrint()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
      </div>
    </div>
    <PdisFooter />
    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex, getMenu } from "@/config/util.js";
import { SearchGovCode, D106_Print } from "@/service/api.js";
export default {
  name: "D106",
  data: function () {
    return {
      pageData: {
        MenuIndex: 3,
        MenuName: "",
        PrgName: "D106",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      form: {
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        syear: String(new Date().getFullYear() - 1911),
        printtype: "XLSX",
      },
      dropDownList: {
        syears: [],
        jobGovCode1s: [],
        jobGovCode2s: [],
        jobGovCode3s: [],
        jobGovCode4s: [],
      },

      Alert: {
        show: false,
        title: "",
        txt: "",
        BtnConfirm: function () {
          this.show = false;
        },
      },
      host: window.location.host,
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
  },
  methods: {
    getSyearDropDownList: function () {
      let syears = [];
      const startYear = "099";
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別
    getSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    btnPrint: function () {
      const self = this;
      let postData = {
        syear: self.form.syear,
        goV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        govcheck: self.form.jobGovCheck,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "產生報表",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        printtype: self.form.printtype,
      };
      if (self.form.printtype == "ODS") {
        D106_Print(postData).then((rData) => {
          if (rData) {
            let link = document.createElement("a");
            link.download =
              self.form.syear + "年度公職人員財產申報實質審核中籤名單.ods";
            link.href = "data:application/doc;base64," + rData;
            link.click();
          } else {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["查無資料"];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
            };
          }
        });
      } else {
        D106_Print(postData).then((rData) => {
          if (rData) {
            let link = document.createElement("a");
            link.download =
              self.form.syear + "年度公職人員財產申報實質審核中籤名單";
            link.href =
              "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
              rData;
            link.click();
          } else {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["查無資料"];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
            };
          }
        });
      }
    },
    btnClear: function () {
      const self = this;
      self.form = {
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        syear: String(new Date().getFullYear() - 1911),
      };
      self.JobGovCodeInit(self.form);
      self.getSearchJobGovCode1();
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    JobGovCode1Change: function () {
      const self = this;
      self.form.jobGovCode2 = "";
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode2s = [];
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode2Change: function () {
      const self = this;
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode3Change: function () {
      const self = this;
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode4s = [];
    },
  },
  watch: {
    "form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode2(newValue);
    },
    "form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode3(newValue);
    },
    "form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode4(newValue);
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.syears = self.getSyearDropDownList();
    self.JobGovCodeInit(self.form);
    self.getSearchJobGovCode1();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
